/**
 * @description transform customDetails array to object
 * @param {Array<{ name: string; value: string }>} [customDetails]
 *
 * @return {Record<string, string>}
 * */
const getCustomDetails = (customDetails) => {
  if (!Array.isArray(customDetails)) return {};

  return customDetails.reduce((acc, { name, value }) => {
    acc[name] = value;

    return acc;
  }, {});
};

export default function select({ customVariables /* customVariables is omitted */, ...data }) {
  return {
    ...data,
    prospects: data?.prospects.map(({ prospect, lead, status, customDetails, ...rest }) => ({
      ...rest,
      lead: lead || prospect, // rename prospect to lead
      status: status === null ? "active" : status,
      customDetails: getCustomDetails(customDetails),
    })),
  };
}
